import AddCollaborativeModalContainer from './containers/AddCollaborativeModalContainer'

export default AddCollaborativeModalContainer
